import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Space, message } from 'antd';
import type { InputNumberProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PlayCircleOutlined } from '@ant-design/icons';

const EditResultGame: React.FC = () => {
  const [form] = Form.useForm();
  const [predictionStatus, setPredictionStatus] = useState<boolean>(false);
  const [currentPrediction, setCurrentPrediction] = useState<{result: number, resultDetail: string} | null>(null);

  const handleOpenCasino = () => {
    window.open('/casino', '_blank');
  };

  useEffect(() => {
    const checkPrediction = () => {
      const storedPrediction = localStorage.getItem('resultNext');
      if (storedPrediction) {
        const data = JSON.parse(storedPrediction);
        setCurrentPrediction(data);
        setPredictionStatus(true);
      } else {
        setCurrentPrediction(null);
        setPredictionStatus(false);
      }
    };
    checkPrediction();
  }, []);

  const onFinish = (values: any) => {
    const { result } = values;
    const resultDetail = result % 2 === 0 ? 'Con' : 'Cái';
    
    const predictionData = {
      result,
      resultDetail
    };

    localStorage.setItem('resultNext', JSON.stringify(predictionData));
    setCurrentPrediction(predictionData);
    setPredictionStatus(true);
    message.success('Đã lưu dự đoán kết quả tiếp theo!');
  };

  const checkPrediction = () => {
    const storedPrediction = localStorage.getItem('resultNext');
    if (storedPrediction) {
      const data = JSON.parse(storedPrediction);
      setCurrentPrediction(data);
      setPredictionStatus(true);
      message.info(`Đã dự đoán kết quả tiếp theo: ${data.resultDetail} (Tổng số: ${data.result})`);
    } else {
      setCurrentPrediction(null);
      setPredictionStatus(false);
      message.warning('Chưa có dự đoán kết quả tiếp theo!');
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card 
        title="Dự đoán kết quả tiếp theo" 
        bordered={false}
        extra={
          <Button 
            type="primary" 
            icon={<PlayCircleOutlined />}
            onClick={handleOpenCasino}
            style={{ 
              background: '#1890ff',
              borderColor: '#1890ff',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            Tới sảnh trò chơi
          </Button>
        }
      >
        <Form
          form={form}
          name="predictionForm"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            label="Tổng số tính toán"
            name="result"
            rules={[{ required: true, message: 'Vui lòng nhập tổng số tính toán!' }]}
          >
            <Input type="number" placeholder="Nhập tổng số tính toán" />
          </Form.Item>

          <Form.Item
            label="Dự đoán kết quả tiếp theo"
            shouldUpdate={(prevValues, currentValues) => 
              prevValues.result !== currentValues.result
            }
          >
            {() => {
              const result = form.getFieldValue('result');
              const resultDetail = result ? (Number(result) % 2 === 0 ? 'Con' : 'Cái') : '';
              return (
                <div style={{ 
                  padding: '8px 12px', 
                  border: '1px solid #d9d9d9',
                  borderRadius: '6px',
                  backgroundColor: '#fafafa',
                  minHeight: '32px'
                }}>
                  {resultDetail || '?'}
                </div>
              );
            }}
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Lưu dự đoán
              </Button>
              <Button type="default" onClick={checkPrediction}>
                Kiểm tra dự đoán
              </Button>
            </Space>
          </Form.Item>
        </Form>

        <div style={{ marginTop: '20px' }}>
          <p>Trạng thái: {predictionStatus ? `Đã dự đoán: ${currentPrediction?.result} (${currentPrediction?.resultDetail})` : 'Chưa dự đoán kết quả tiếp theo'}</p>
        </div>
      </Card>
    </div>
  );
};

export default EditResultGame; 